<template>
  <div class="table-list page-box">
    <div class="page-content">
      <div class="content-header">

        <vs-button
          class="search-btn btn box-item"
          @click="searchHandle"
        >刷新</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              维度名称
            </vs-th>
            <vs-th>
              维度值
            </vs-th>
            <vs-th>
              维度类型
            </vs-th>
            <vs-th>
              备注
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td>
                {{tr.nodeName}}
              </vs-td>
              <vs-td>
                {{tr.nodeValue}}
              </vs-td>
              <vs-td>
                {{tr.dimensionName || '-'}}
              </vs-td>
              <vs-td>
                {{tr.remark || '-'}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { treeDataTranslate } from '@/utils/common'
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {
  },
  data() {
    return {
      name: '',
      selected: [],
      typeList: [],
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init().then((res) => {
      this.listData = treeDataTranslate(res.page.list);
    });
  },
  methods: {
    beforeInit(){
      this.url = '/wx/sys/dataPermissionTree/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc'
      }
      return true;
    },

    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.table-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
